<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="批量更新"
      :innerHeight="400"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <!-- {{currentNode.taskId}}/{{activeStepIndex}} -->
      <el-form :model="form" :inline="true" size="mini">
        <el-form-item label="SKU编码">
          <el-input v-model.trim="form.skuCode" style="width: 100px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="SKU进度">
          <el-select v-model="form.taskId">
            <el-option label="全部" value=""></el-option>
            <el-option :label="item.label" :value="item.value" v-for="item in skuProcessPotions" :key="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="进度状态">
          <el-select v-model="form.isRenderStart">
            <el-option label="全部" value=""></el-option>
            <el-option label="已开始" :value="1"></el-option>
            <el-option label="未开始" :value="null"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        stripe
        :header-cell-style="{backgroundColor: '#F4F8FB'}"
        :data="tableData"
        :height="300"
        border
        @selection-change="onSelectChange"
        ref="table"
        v-if="tableReload"
        :class="{'hidden-check-all': hiddenCheckAll}"
      >
        <el-table-column type="selection" :selectable='checkboxT'></el-table-column>
        <el-table-column label="SKU编码" prop="skuCode" show-overflow-tooltip></el-table-column>
        <el-table-column label="SKU名称" prop="skuName" show-overflow-tooltip></el-table-column>
        <el-table-column label="SKU进度" prop="taskName" show-overflow-tooltip>
          <template> 渲染 </template>
        </el-table-column>
        <!-- <el-table-column label="是否计划" prop="isPlan" show-overflow-tooltip></el-table-column>
        <el-table-column label="是否开始" prop="isStart" show-overflow-tooltip></el-table-column> -->
        <el-table-column label="进度状态" prop="isRenderStart" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.isRenderStart == 1">已开始</span>
            <span v-else>未开始</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div style="text-align: right; margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationOpt.pageNum"
          :page-sizes="paginationOpt.pageSizes"
          :page-size="paginationOpt.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paginationOpt.total">
        </el-pagination>
      </div> -->
      <!-- <div class="node-name">{{currentNode.taskName}}</div> -->
      <div>
        <!-- <el-tag
          type="primary"
          v-for="item in selectedData" :key="item.skuCode"
          closable
          size="small"
          @close="handleTagClose(item)"
        >{{item.skuName}}</el-tag> -->
      </div>
      <div class="tips">批量更新，仅支持相同进度和状态的SPU，且后续规划的计划完成时间、配置人员必须相同。</div>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { newProductStepEnum as stepEnum } from '@/utils/constant'
import { mapGetters } from 'vuex'
const allSkuProcessPotions = [
  { label: '开始制作', value: '101' },
  { label: '样品组货', value: '102' },
  { label: '拍摄', value: '103' },
  { label: '修片', value: '104' },
  { label: '设计', value: '107' },
  { label: '切片', value: '108' },
  { label: '准备上架', value: '109' },
]
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'spuId', 'skuList'],
  data() {
    return {
      dialogVisible: false,
      isNeedRefresh: false,
      // 业务
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0
      },
      skuProcessPotions: [],
      form: {
        skuCode: '',
        taskId: '',
        isRenderStart: ''
      },
      selectedData: [],
      tableReload: true,
      stepEnum: stepEnum,
      // 用户拥有的按钮权限
      userPermitList: []
    }
  },
  computed: {
    currentNode() {
      return this.selectedData[0] || {};
    },
    // 当前流程节点index
    // activeStepIndex() {
    //   const stepIndexMap = {
    //     [stepEnum.newArrival]: 0,
    //     [stepEnum.sampleGroup]: 1,
    //     [stepEnum.shooting]: 2,
    //     [stepEnum.retouching]: 3,
    //     [stepEnum.paperwork]: 4,
    //     [stepEnum.design]: 5,
    //     [stepEnum.sectioning]: 6,
    //     [stepEnum.preparation]: 7,
    //     [stepEnum.finished]: 8,
    //   };

    //   // TODO 多个sku，实际流程都在新品上架
    //   // 产品资料节点
    //   if (this.currentNode.taskId === stepEnum.files) {
    //     return 4;
    //   }

    //   if (this.currentNode.taskId === stepEnum.finished) {
    //     return 9;
    //   }

    //   return stepIndexMap[this.currentNode.taskId] || 0;
    // },
    // 节点按钮权限表
    // nodePermitList() {
    //   return {
    //     [Symbol(stepEnum.newArrival)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartPublish',
    //     [Symbol(stepEnum.sampleGroup)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ArrivalPlan',
    //     [Symbol(stepEnum.sampleGroup)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$ConfirmArrival',
    //     [Symbol(stepEnum.shooting)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartShooting',
    //     [Symbol(stepEnum.shooting)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishShooting',
    //     [Symbol(stepEnum.retouching)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartRetouching',
    //     [Symbol(stepEnum.retouching)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishRetouching',
    //     [Symbol(stepEnum.design)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartDesign',
    //     [Symbol(stepEnum.design)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishDesign',
    //     [Symbol(stepEnum.sectioning)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$StartSection',
    //     [Symbol(stepEnum.sectioning)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$FinishSection',
    //     [Symbol(stepEnum.preparation)]: 'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$PublishNow'
    //   }
    // },
    // 是否隐藏全选按钮
    hiddenCheckAll(){
      let start = this.tableData.filter(v=> v.isRenderStart == 1).length
      let end = this.tableData.filter(v=> v.isRenderStart != 1).length
      if(start == this.tableData.length || end == this.tableData.length) {
        // 显示
        return false
      }else{
        // 隐藏
        return true
      }
    }
  },
  created() {
    // this.userPermitList = JSON.parse(localStorage.getItem('permitList'));
    this.search();
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
    console.log(this.tableData);
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('update:visible', false)
      },200)
    },
    confirm() {
      if(!this.selectedData.length) {
        this.$message.error(`请勾选需批量操作的SKU！`);
        return;
      }
      if(this.selectedData.filter(v=>v.isRenderPlan == 1).length != this.selectedData.length){
        this.$message.error(`请维护渲染计划`);
        return;
      }
      
      let params = {
        type: this.currentNode.isRenderStart == 1,
        skuId: this.selectedData.map(v=>v.dataId),
        skuCode: this.selectedData.map(v=>v.skuCode),
        taskId: this.currentNode.taskId,
        // 公共方法startTask，在处于修片才会传spuId, 准备上架会传spuid
        spuId: '',
        tableData: null
      };
      this.$emit('complete', params);
      this.updateVal();
    },
    // 业务
    // // 分页器 pagesize
    // handleSizeChange(val) {
    //   this.paginationOpt.pageSize = val;
    //   this.paginationOpt.pageNum = 1;
    // },
    // // 分页器 pageNum
    // handleCurrentChange(val) {
    //   this.paginationOpt.pageNum = val;
    // },
    search() {
      // 过滤掉isSkipDemand==1(订单制)的数据； 注： 订单制的数据不参与批量更新
      this.tableData = this.skuList.filter(v=>v.isSkipDemand != 1 && v.isCompleteRendering != 1)
      // 添加可选字段
      this.tableData = this.tableData.map(v=>{
        return {
          ...v,
          selectable: true
        }
      })
      // 搜索过滤
      this.tableData = this.tableData.filter(v=>{
        return (this.form.skuCode === '' || v.skuCode.includes(this.form.skuCode))
         && (this.form.taskId === '' || v.taskId == this.form.taskId)
         && (this.form.isRenderStart === '' || v.isRenderStart == this.form.isRenderStart)
         // 默认过滤掉已终止的sku
         && !v.isEnd
      });

      // // 权限过滤
      // let hasAuthList = [];
      // Object.getOwnPropertySymbols(this.nodePermitList).forEach(key=>{
      //   if(this.userPermitList.find(v=>v==this.nodePermitList[key])){
      //     hasAuthList.push(key.toString().replace(/Symbol/g, '').split('').slice(1).reverse().slice(1).reverse().join(''));
      //   }
      // });
      // hasAuthList = Array.from(new Set(hasAuthList));
      // console.log(hasAuthList);
      // this.tableData = this.tableData.filter(v=>{
      //   return hasAuthList.indexOf(v.taskId) > -1
      // });
      // this.skuProcessPotions = allSkuProcessPotions.filter(v=>{
      //   return hasAuthList.indexOf(v.value) > -1 && this.skuList.find(k=>k.taskId == v.value)
      // })
    },
    onSelectChange(selection) {
      console.log(selection);
      // 首次选择
      if(!this.selectedData.length) {
        this.tableData.forEach(row=>{
          if(row.isRenderStart != selection[0].isRenderStart) {
            row.selectable = false;
          }
        })
      }

      this.selectedData = selection;

      // 全部取消选择
      if(!this.selectedData.length) {
        this.tableData.forEach(row=>{
          row.selectable = true;
        })
      }
    },
    checkboxT(row, rowIndex) {
      return row.selectable;
    },
    handleTagClose(item) {
      this.selectedData = this.selectedData.filter(v=>v.skuCode !== item.skuCode);
      this.$refs['table'].toggleRowSelection(item)
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-tag
    margin-right 10px
    margin-top 10px
    max-width 120px
    overflow hidden
    text-overflow ellipsis
    position relative
  >>> .el-tag__close
    position absolute
    right 3px
    top 3px 
    z-index 10
    &::before
      color rgba(0,0,0,0.5)
  .tips
    color #E63946
    margin-top 10px

  .hidden-check-all >>> thead .el-table-column--selection
    .cell
      display none

  .node-name
    margin-top 10px
    font-weight bold

  >>> .el-form .el-select, >>> .el-form .el-input
    width 100px
</style>